export const versionManifestPath = "/version.json"

const preloadReloadKey = "farol-preload-error-reload-v1"
const preloadReloadWindowMs = 10_000

export async function fetchPublishedVersion(fetcher: typeof fetch = fetch): Promise<string | null> {
  try {
    const response = await fetcher(versionManifestPath, { cache: "no-store", headers: { Accept: "application/json" } })
    if (!response.ok) return null
    const manifest: unknown = await response.json()
    if (!manifest || typeof manifest !== "object") return null
    const version = (manifest as { version?: unknown }).version
    return typeof version === "string" && version.trim() ? version.trim() : null
  } catch {
    // Offline, blocked or mid-deploy: try again on the next check.
    return null
  }
}

// After a deploy, an open tab may request a lazy chunk that no longer exists.
// Reload once to pick up the new build; a second failure within the window
// surfaces the error instead of looping.
export function installPreloadErrorRecovery(reload: () => void = () => window.location.reload()) {
  window.addEventListener("vite:preloadError", (event) => {
    const now = Date.now()
    try {
      const lastReload = Number(window.sessionStorage.getItem(preloadReloadKey))
      if (lastReload && now - lastReload < preloadReloadWindowMs) return
      window.sessionStorage.setItem(preloadReloadKey, String(now))
    } catch {
      return
    }
    event.preventDefault()
    reload()
  })
}
